module.exports = __webpack_public_path__ + "static/learning-primary2@large-4fc985cd8005cb4f4b2fc7903770d0f3.jpg";